// Values feed a upi://pay intent URI, so charsets stay conservative and match server-side validation
// (VeerSubscriptionHub OperatorController, VMS ClientService).
export const UPI_VPA_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9._-]{1,255}@[a-zA-Z]{2,64}$/;

const NOTE_ALLOWED_CHARS = /[^A-Za-z0-9 ._-]/g;
const NOTE_MAX_LENGTH = 50;

export function isValidUpiVpa(upiId: string | null | undefined): boolean {
  return !!upiId && UPI_VPA_REGEX.test(upiId.trim());
}

export function sanitizeUpiNote(note: string): string {
  return note
    .replace(NOTE_ALLOWED_CHARS, '')
    .replace(/\s+/g, ' ')
    .trim()
    .slice(0, NOTE_MAX_LENGTH);
}

export interface UpiIntentParams {
  pa: string;
  pn: string;
  am: number;
  tn?: string;
}

/** Builds a `upi://pay` deep link. Returns null if the VPA or amount can't produce a valid QR. */
export function buildUpiIntentUri({ pa, pn, am, tn }: UpiIntentParams): string | null {
  if (!isValidUpiVpa(pa) || !(am > 0)) {
    return null;
  }

  const parts = [
    `pa=${encodeURIComponent(pa.trim())}`,
    `pn=${encodeURIComponent(pn.trim())}`,
    `am=${encodeURIComponent(am.toFixed(2))}`,
    'cu=INR',
  ];

  const note = tn ? sanitizeUpiNote(tn) : '';
  if (note) {
    parts.push(`tn=${encodeURIComponent(note)}`);
  }

  return `upi://pay?${parts.join('&')}`;
}
